import axios from 'axios'
import { isObject } from './helpers.js'

/**
 * @param {Object} request
 * @returns {Object}
 * @description Transforms the response object that is received, here we can
 * also fix the akero responses so that IE11 correctly works.
 */
function transformResponse(response) {
  if (!isObject(response)) {
    try {
      return JSON.parse(response)
    } catch (ex) {
      console.log(ex)
    }
  }
  return response
}

/**
 * @type
 * @description This is the instance of axios that should be used throughout
 * the application, since this once will be pre-configured with the needed
 * headers to communicate with the Akerolabs API and Admin panel servers.
 *
 * Any options applied here can be overridden in any requests.
 */
export const request = axios.create({
  baseURL: 'http://l.api.akerolabs.com',
  responseType: 'json',
  responseEncoding: 'utf8',
  transformResponse: [transformResponse],
  headers: {},
})

/**
 * @param {String} url
 * @description Sets the base url for the request library to use. This will
 * allow the different environments to change the API url as we need to.
 */
export const setBaseUrl = (url) => {
  if (typeof url === 'string') {
    request.defaults.baseURL = url
  }
}

/**
 * @param {String} type
 * @param {String} value
 * @description Sets the a header for the request library to use. This will
 * allow things like authentication headers to be auto set for logged in
 * users.
 */
export const setHeader = (type, value) => {
  if (typeof type === 'string' && value) {
    request.defaults.headers[type] = value
  }
}

/**
 * @param {Mixed}
 * @returns {Promise}
 * @description Allows the user to make a GET request to an endpoint
 * @example
 * request.get('/user/12345', {
 *  params: {
 *   firstName: 'Fred',
 *   lastName: 'Flintstone'
 *  }
 * })
 *  .then(console.log)
 *  .catch(console.error)
 */
export const get = (...args) => request.get(...args)

/**
 * @param {Mixed}
 * @returns {Promise}
 * @description Allows the user to make a PUT request to an endpoint
 * @example
 * request.put('/user/12345', {
 *  data: {
 *   firstName: 'Fred',
 *   lastName: 'Flintstone'
 *  }
 * })
 *  .then(console.log)
 *  .catch(console.error)
 */
export const put = (...args) => request.put(...args)

/**
 * @param {Mixed}
 * @returns {Promise}
 * @description Allows the user to make a POST request to an endpoint
 * @example
 * request.post('/user/12345', {
 *  data: {
 *   firstName: 'Fred',
 *   lastName: 'Flintstone'
 *  }
 * })
 *  .then(console.log)
 *  .catch(console.error)
 */
export const post = (...args) => request.post(...args)

/**
 * @param {Mixed}
 * @returns {Promise}
 * @description Allows the user to make a DELETE request to an endpoint
 * @example
 * request.remove('/user/12345')
 *  .then(console.log)
 *  .catch(console.error)
 */
export const remove = (...args) => request.delete(...args)

/**
 * @param {Mixed}
 * @returns {Promise}
 * @description Allows the user to make a request to an endpoint
 * @example
 * request({
 *  method: 'post',
 *  url: '/user/12345',
 *  data: {
 *   firstName: 'Fred',
 *   lastName: 'Flintstone'
 *  }
 * })
 *  .then(console.log)
 *  .catch(console.error)
 */
export default (...args) => request(...args)
